import { styled } from '@mui/material/styles';

const MapSidebar = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  backgroundColor: theme.palette.background.default,
  width: '50vw',
  maxWidth: '460px',
  position: 'relative',
  overflowY: 'auto',
  overflowX: 'hidden',
  zIndex: 1,
  borderRight: `1px solid ${theme.palette.divider}`
}));

export default MapSidebar;